import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './app/i18n';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('main: #root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
